<template>
  <nav aria-label="breadcrumb" class="breadcrumb_wrapper" style="--bs-breadcrumb-divider: '\f10e';">
    <!-- Apply dynamic class binding to the container -->
    <div  :class="{ 'container': isContainer }">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <NuxtLink to="/">
            <i class="fi-rr-home"></i> الرئيسية
          </NuxtLink>
        </li>
        <li 
          v-for="(crumb, index) in paths" 
          :key="index" 
          class="breadcrumb-item"
          :class="{ active: index === paths.length - 1 }"
        >
          <template v-if="index !== paths.length - 1">
            <NuxtLink :to="crumb.link">{{ crumb.label }}</NuxtLink>
          </template>
          <template v-else>
            <span>{{ crumb.label }}</span>
          </template>
        </li>
      </ol>
    </div>
  </nav>
</template>

<script setup lang="ts">

interface BreadcrumbItem {
  label: string;
  link: string;
}

const props = defineProps<{
  paths: BreadcrumbItem[],
  isContainer?: boolean // optional boolean flag to add a dynamic class
}>()
</script>

